import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import TourPackageCard from "./TourPackageCard";
import backgroundImage from "../../assets/places/tower.jpg";
import singapore from "../../assets/places/singapur/singapur4.jpg";
import backgroundImage1 from "../../assets/places/temple.jpg";
import backgroundImage2 from "../../assets/places/sight.jpg";
import backgroundImage3 from "../../assets/places/dubai.jpg";
import dubai from "../../assets/places/dubai/dubai.jpg";
import dubai1 from "../../assets/places/dubai/dubai1.jpg";
import dubai2 from "../../assets/places/dubai/dubai2.jpg";
import dubai3 from "../../assets/places/dubai/dubai3.jpg";
import dubai6 from "../../assets/places/dubai/dubai6.jpg";
import dubai7 from "../../assets/places/dubai/dubai7.jpg";
import dubai8 from "../../assets/places/dubai/dubai8.jpg";
import dubai9 from "../../assets/places/dubai/dubai9.jpg";
import dubai10 from "../../assets/places/dubai/dubai10.jpg";
import dubai5 from "../../assets/places/dubai/dubai5.jpg";
import dubai4 from "../../assets/places/dubai/dubai4.jpg";
import dubai12 from "../../assets/places/dubai/dubai12.jpg";
import malaysia from "../../assets/places/malaysia/malaysia.jpg";
import malaysia1 from "../../assets/places/malaysia/malaysia1.jpg";
import malaysia2 from "../../assets/places/malaysia/malaysia2.jpg";
import malaysia3 from "../../assets/places/malaysia/malaysia3.jpg";
import malaysia4 from "../../assets/places/malaysia/malaysia4.jpg";
import malaysia5 from "../../assets/places/malaysia/malaysia5.jpg";
import malaysia6 from "../../assets/places/malaysia/malaysia6.jpg";
import malaysiaBackground from "../../assets/places/malaysia/malaysia4.jpg";
import bali from "../../assets/places/bali/bali.jpg";
import bali1 from "../../assets/places/bali/bali1.jpg";
import bali2 from "../../assets/places/bali/bali2.jpg";
import bali3 from "../../assets/places/paris/bali10.jpg";
import bali4 from "../../assets/places/paris/bali11.jpg";
import bali5 from "../../assets/places/paris/bali12.jpg";
import bali6 from "../../assets/places/paris/bali13.jpg";
import bali7 from "../../assets/places/paris/bali14.jpg";
import singapur from "../../assets/places/singapur/singapur.jpg";
import singapur8 from "../../assets/places/singapur/singapur8.jpg";
import singapur1 from "../../assets/places/singapur/singapur1.jpg";
import singapur2 from "../../assets/places/singapur/singapur2.jpg";
import japan from "../../assets/places/japan/japan.jpg";
import japan1 from "../../assets/places/japan/japan1.jpg";
import japan2 from "../../assets/places/japan/japan2.jpg";
import japan3 from "../../assets/places/japan/japan3.jpg";
import japanBackground from "../../assets/places/japan/japan4.jpg";
import brazil1 from "../../assets/places/brazil/brazil.jpg";
import brazil2 from "../../assets/places/brazil/brazil1.jpg";
import brazil3 from "../../assets/places/brazil/brazil2.jpg";
import brazilBackground from "../../assets/places/brazil/brazil3.jpg";
import thailand from "../../assets/places/paris/thailand.jpg";
import thailand1 from "../../assets/places/paris/thailand1.jpg";
import thailand2 from "../../assets/places/paris/thailand2.jpg";
import thailand3 from "../../assets/places/paris/thailand3.jpg";
import thailand4 from "../../assets/places/paris/thailand4.jpg";
import thailand5 from "../../assets/places/paris/thailand5.jpg";
import thailandBackground from "../../assets/places/paris/thailand3.jpg";
import paris from "../../assets/places/paris/paris.jpg";
import paris1 from "../../assets/places/paris/paris1.jpg";
import paris2 from "../../assets/places/paris/paris2.jpg";
import paris3 from "../../assets/places/paris/paris3.jpg";
import paris4 from "../../assets/places/paris/paris4.jpg";
import paris5 from "../../assets/places/paris/paris5.jpg";
import paris6 from "../../assets/places/paris/paris6.jpg";
import paris7 from "../../assets/places/paris/paris7.jpg";
import france from "../../assets/places/paris/france.jpg";
import france1 from "../../assets/places/paris/france1.jpg";
import france2 from "../../assets/places/paris/france2.jpg";
import france3 from "../../assets/places/paris/france3.jpg";
import france4 from "../../assets/places/paris/france4.jpg";
import france5 from "../../assets/places/paris/france5.jpg";
import france6 from "../../assets/places/paris/france6.jpg";
import maldives from "../../assets/places/paris/maldives.jpg";
import maldives1 from "../../assets/places/paris/maldives1.jpg";
import maldives2 from "../../assets/places/paris/maldives2.jpg";
import maldives3 from "../../assets/places/paris/maldives3.jpg";
import maldives4 from "../../assets/places/paris/maldives4.jpg";
import maldives5 from "../../assets/places/paris/maldives5.jpg";
import parisBackground from "../../assets/places/paris/paris3.jpg";

export const packages = [
  {
    title: "Dubai Tour Package",
    pricing: 37950,
    originalPrice: 58000,
    duration: "4 Days / 3 Nights",
    features: [
      "Burj Khalifa (124th Floor) Ticket",
      "Museum of the Future Entry",
      "4-Star Accommodation with Breakfast",
      "Desert Safari with BBQ Dinner",
      "Dhow Cruise Dinner",
      "VISA Assistance and Travel Insurance",
    ],
    itinerary: [
      {
        day: "Day 1 - Arrival in Dubai & Dinner at Dhow Cruise",
        detail:
          "Arrive in Dubai and embark on a memorable evening with a lavish dinner aboard a traditional Dhow Cruise. Admire Dubai's stunning architecture and glittering structures as you sail by, accompanied by beautiful Arabic music. After the cruise, you'll be transferred to your hotel for an overnight stay.",
      },
      {
        day: "Day 2 - Half-day City Tour and Burj Khalifa",
        detail:
          "Gaze at the magnificent views from the 124th floor of Burj Khalifa. Begin your day with a city tour starting at the beautiful Jumeirah Beach. Marvel at the iconic Atlantis Hotel on Palm Jumeirah. After the tour, you'll be transferred back to your hotel for an overnight stay.",
      },
      {
        day: "Day 3 - Desert Safari",
        detail:
          "Enjoy a spread of fresh breakfast at your hotel and spend the first half of the day leisurely. In the evening, leave for the Dubai Desert Safari Tour. Enjoy an adrenaline-pumping ride on the fascinating dunes of Dubai. Later, get to your hotel for a sound sleep.",
      },
      {
        day: "Day 4 - Departure",
        detail:
          "Enjoy a hearty breakfast at your hotel. Pack your belongings and complete the check-out formalities. Get to the airport, and board your flight back home with lovely memories of your fun-filled Dubai vacation!",
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Sightseeing in shared vehicle",
      "Accommodation in a 4-star hotel",
    ],
    exclusions: [
      "Personal expenses",
      "Entry fees to attractions not mentioned in inclusions",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Romantic Dubai Retreat With FREE Parks & Resorts Tickets",
        duration: "7 days & 6 nights",
        price: "INR 86,000",
        originalPrice: "INR 1,00,225",
        discount: "Save INR 14,225",
        rating: 4.6,
        reviews: 170,
        image: dubai9,
      },
      {
        id: 2,
        title: "Dubai Delights | Crossroad Cultures Of The Middle East",
        duration: "6 days & 5 nights",
        price: "INR 67,074",
        originalPrice: "INR 89,000",
        discount: "Save INR 21,926",
        rating: 5.0,
        reviews: 100,
        image: dubai6,
      },
      {
        id: 3,
        title: "Getaway To Dubai | Sands, Skyscrapers And Sea",
        duration: "5 days & 4 nights",
        price: "INR 45,000",
        originalPrice: "INR 56,322",
        discount: "Save INR 11,322",
        rating: 4.9,
        reviews: 1500,
        image: dubai7,
      },
    ],
    carousalImages: backgroundImage3,
    imageUrl: [dubai3, dubai4, dubai8, dubai10, dubai12],
  },
  {
    title: "Bali Tour Package",
    pricing: 24860,
    originalPrice: 69999,
    duration: "5 Days / 4 Nights",
    features: [
      "Tanah Lot Temple Visit",
      "Uluwatu Temple Sunset Tour",
      "4-Star Beach Resort with Breakfast",
      "Snorkeling and Water Sports Activities",
      "Cultural Dance Performances",
      "VISA Assistance and Travel Insurance",
    ],
    itinerary: [
      {
        day: "Day 1: Bali: Airport Pick up and Uluwatu Sunset Tour",
        detail:
          "Pick up at the airport and drop to your hotel for check in\nPick up to visit Uluwatu Temple in the south part of Bali\nWatching Kecak Dance show set on a high cliff Uluwatu overlooking the Indian ocean – Enjoy the best sunset view here.\nDrive to Jimbaran Beach for fresh seafood dinner and drop back to the hotel afterward.",
      },
      {
        day: "Day 2: Bali: Ubud, Kintamani and Waterfall Tour",
        detail:
          "Pick up at the hotel\nDiscover Ubud Sanctuary Monkey Forest\nBreak for Herbal Tea and try the most expensive Luwak Coffee in Umapakel Agro Tourism. The Swing activity is also available here.\nTrekking through Tegalalang Rice Terrace\nLunch at Kintamani slope cafe overlooking Mt. Batur volcano caldera and Batur Lake\nVisit Tirta Empul Temple\nDiscover Tegenungan Waterfall. You are free to bathe at this natural rock pool\nBack to the Hotel.",
      },
      {
        day: "Day 3: Bali: Bedugul and Tanah Lot Tour",
        detail:
          "Pick up at the hotel\nDeliver your pic style at Wanagiri Hidden Hill with Tamblingan lake breathtaking view and Handara Gate – an iconic gate in Bedugul\nExploring Ulun Danu Temple, a temple located on Beratan Lake\nBreak for Lunch\nDo short trekking through Jatiluwih Rice terrace, a UNESCO world heritage site\nVisit Tanah Lot Temple for another sunset view\nBack to the hotel.",
      },
      {
        day: "Day 4: Bali: East Tour – Lempuyang Gate of the Heaven and Tirta Gangga",
        detail:
          "Pick up at the hotel\nVisit Lempuyang Temple, known as gate of the heaven\nExploring Tirta Gangga Water Palace – Encounter the story of the king palace\nEnjoying Lunch at Karang Asem Resto\nExploring Tenganan Village – The only old Bali Village that still exists until now\nVisit Goa Lawah Temple – Seeing Hundreds of Bat hanging at the cave\nBack to hotel.",
      },
      {
        day: "Day 5: Bali: Departure",
        detail: "Pick up at the hotel and drop to airport.",
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Snorkeling gear and guide",
      "4-Star accommodation",
    ],
    exclusions: [
      "Personal expenses",
      "Special dinner requests",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Bali Bliss | Tropical Paradise",
        duration: "6 days & 5 nights",
        price: "INR 59,750",
        originalPrice: "INR 1,00,225",
        discount: "Save INR 40,475",
        rating: 4.6,
        reviews: 170,
        image: bali3, // Replace with actual image variable for Bali
      },
      {
        id: 2,
        title: "Bali Adventure | Beaches and Volcanoes",
        duration: "8 days & 7 nights",
        price: "INR 75,499",
        originalPrice: "INR 90,000",
        discount: "Save INR 14,501",
        rating: 4.8,
        reviews: 220,
        image: bali7, // Replace with actual image variable for Bali
      },
      {
        id: 3,
        title: "Bali Culture and Relaxation | Temples and Spas",
        duration: "7 days & 6 nights",
        price: "INR 1,25,000",
        originalPrice: "INR 1,40,000",
        discount: "Save INR 15,000",
        rating: 4.9,
        reviews: 350,
        image: bali6, // Replace with actual image variable for Bali
      },
    ],
    carousalImages: backgroundImage1,
    imageUrl: [bali3, bali4, bali5, bali7],
  },
  {
    title: "Singapore Tour Package",
    pricing: 24650,
    originalPrice: 49999,
    duration: "5 Days / 4 Nights",
    features: [
      "Gardens by the Bay Entry",
      "Sentosa Island Cable Car Ride",
      "Universal Studios Singapore Ticket",
      "4-Star Hotel Accommodation",
      "Night Safari Experience",
      "VISA Assistance and Travel Insurance",
    ],
    itinerary: [
      {
        day: "Day 1: Singapore",
        detail:
          "Upon arrival at Singapore international airport. Outside customs you will meet our representative, Welcome and transfer to a pre booked hotel in Singapore. Day free on your own. Night Safari tour. The tour starts at around 1800 hours and you will witness only one of its kind night safari in Far East Asia. Overnight at any good Hotel.",
      },
      {
        day: "Day 2: Singapore Sightseeing",
        detail:
          "After breakfast at the hotel, Sightseeing tour of Singapore, Visiting national stadium, police head quarter, merlion and by-pass to many parts of Singapore, Mount Faber etc. Tour to Sentosa Island including (Entrance, Cable car one way , Underwater world. Overnight at any good Hotel.",
      },
      {
        day: "Day 3: Singapore - Batam Island",
        detail:
          "Breakfast at the Hotel. On time transfer From Singapore Hotel to Pier Point to Board the Ferry for Batam Island. It will take around 45 minutes to reach there. Check in to the hotel. Sightseeing tour of Batam Island. Local Sea food Lunch during the sightseeing tour and Dinner on your own. Free for night life. Overnight at any good Hotel.",
      },
      {
        day: "Day 4: Batam Island - Singapore",
        detail:
          "Breakfast at the Hotel. Free time on time transfer to ferry point to board the ferry for Singapore. Upon arrival you will meet our representative. Overnight at any good Hotel.",
      },
      {
        day: "Day 5: Singapore - Departure",
        detail:
          "Have a delectable breakfast at the hotel. Later, pack your bags and complete all the check-out formalities. You will get a transfer to Singapore Airport from where you can board a flight back to your place.",
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Entry to all attractions mentioned",
      "4-Star accommodation",
    ],
    exclusions: [
      "Personal expenses",
      "Extra meals not mentioned in itinerary",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Singapore Extravaganza | Urban Wonders",
        duration: "4 days & 3 nights",
        price: "INR 36,500",
        originalPrice: "INR 96,000",
        discount: "Save INR 59,599",
        rating: 4.6,
        reviews: 170,
        image: singapur, // Replace with actual image variable for Singapore
      },
      {
        id: 2,
        title: "Singapore Adventure | Gardens by the Bay and More",
        duration: "5 days & 4 nights",
        price: "INR 60,000",
        originalPrice: "INR 80,000",
        discount: "Save INR 20,000",
        rating: 4.8,
        reviews: 250,
        image: singapur1, // Replace with actual image variable for Singapore
      },
      {
        id: 3,
        title: "Singapore Family Fun | Universal Studios and Sentosa",
        duration: "6 days & 5 nights",
        price: "INR 70,000",
        originalPrice: "INR 95,000",
        discount: "Save INR 25,000",
        rating: 4.9,
        reviews: 300,
        image: singapur2, // Replace with actual image variable for Singapore
      },
    ],
    carousalImages: backgroundImage2,
    imageUrl: [singapur, singapur1, singapur2],
  },
  {
    title: "Thailand Tour Package",
    pricing: 46470,
    originalPrice: 75000,
    duration: "7 Days / 6 Nights",
    features: [
      "Grand Palace Visit",
      "Phi Phi Islands Tour",
      "4-Star Beach Resort Accommodation",
      "Floating Market Experience",
      "Thai Cultural Dinner Show",
      "VISA Assistance and Travel Insurance",
    ],
    itinerary: [
      {
        day: "Day 1: Phuket: Arrival & Leisure Day",
        detail:
          "Upon arrival at the international airport in Phuket, the agent’s representative will receive and help you with smooth transfers to the hotel. As you reach the hotel, check in and relax as you have the rest of the day at leisure. Enjoy relaxing indoors or go out and explore the local surroundings. Don’t forget to try out local cuisines of Phuket in the evening. When dusk falls and the day ends, get back to your hotel for a good night’s sleep.",
      },
      {
        day: "Day 2: Phuket: Phi Phi island tour by Big Boat",
        detail:
          "The day starts with a wholesome breakfast at the hotel after which you will be taken for a tour of the much popular and equally beautiful Phi Phi Island. The day will proceed with a drive that will take you through Northern parts of Phi Phi Island. Here, you will get to visit Bamboo Island, which is an ideal place for snorkeling due to its geography. Moving forward, you will be visiting Maya Bay. It is where the movie The Beach was filmed. As the day ends, return to the hotel for an overnight stay.",
      },
      {
        day: "Day 3: Phuket - Krabi: Transfer & Leisure Day",
        detail:
          "Have a sumptuous breakfast at the hotel and check out as then you will be transferred to the next destination in Thailand - Krabi. Enjoy journeying through the beautiful landscape and soak in the natural bliss that surrounds you. Post arrival at the hotel in Krabi, check in at the hotel and spend the remaining part of the day at leisure. You may explore the place and nearby attractions on your own or stay inside the hotel room and relax. The day ends with a cozy overnight stay at the hotel.",
      },
      {
        day: "Day 4: Krabi: Four Island Tour via Join Speed Boat",
        detail:
          "After a scrumptious breakfast, this Thailand tour package takes you out for an island tour which includes visits to Chicken Island, Tup Island, and Poda Island. Take joy in cruising over the deep blue Andaman Sea and be awed by the splendid natural beauty. As dusk falls and the day tour comes to an end, you will be transferred to the hotel for an overnight stay.",
      },
      {
        day: "Day 5: Krabi - Bangkok: Transfer to Bangkok via Phuket & Chao Phraya Princess Dinner Cruise",
        detail:
          "Wake up to a delectable breakfast, check-out from the hotel and then you will be transferred to the airport in Phuket from where you will board the flight to Bangkok. Post your arrival at the airport in Bangkok, you will be received by the concerned agent’s representative who will arrange your transfers to the hotel. As you reach the hotel, complete the check-in formalities. In the evening, the Thailand holiday itinerary takes you for a stylish and luxurious Chao Phraya Dinner cruise where you can enjoy live music performance, entertainment shows and treat yourself to lip-smacking international buffet dinner. At the end of the day, you will be transferred to the hotel for an overnight stay.",
      },
      {
        day: "Day 6: Krabi - Bangkok: City Tour, Madame Tussauds, & Sea Life",
        detail:
          "Have a filling breakfast and get ready for a full day Bangkok city tour that takes you to some of the most sought after tourist attractions in Bangkok. The tour starts with a trip to Wat Traimit (the Temple of Golden Buddha) and Wat Benchamabophit Dusitvanaram (the marble temple). Later, enjoy a visit to Madame Tussauds and Sea Life. Explore the marvels of the underwater world as you visit Sea Life Bangkok. There are many fun-filled activities in which you can partake here. Then, you will get to visit the intriguing Madame Tussauds Museum. It is home to numerous wax statues of famous people from across the world. End the day with a peaceful stay at the hotel.",
      },
      {
        day: "Day 7: Krabi - Bangkok: Departure",
        detail:
          "Have a sumptuous breakfast at the hotel and check out as it’s time to leave. An engaging Thailand tour ends as now you get ready to be transferred to Bangkok Airport for your journey back home.",
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Phi Phi Islands tour with snorkeling",
      "4-Star accommodation",
    ],
    exclusions: [
      "Personal expenses",
      "Special dinner requests",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Thailand Beaches and Markets Tour",
        duration: "8 days & 7 nights",
        price: "INR 49,500",
        originalPrice: "INR 55,000",
        discount: "Save INR 5,500",
        rating: 4.7,
        reviews: 200,
        image: thailand, // Replace with actual image variable
      },
      {
        id: 2,
        title: "Thailand Adventure | Islands and Culture",
        duration: "6 days & 5 nights",
        price: "INR 80,000",
        originalPrice: "INR 90,000",
        discount: "Save INR 10,000",
        rating: 4.9,
        reviews: 150,
        image: thailand5, // Replace with actual image variable
      },
      {
        id: 2,
        title: "Thai Odyssey: Island Hopping and Cultural Wonders",
        duration: "6 days & 5 nights",
        price: "INR 64,900",
        originalPrice: "INR 99,000",
        discount: "Save INR 34,100",
        rating: 4.9,
        reviews: 150,
        image: thailand4, // Replace with actual image variable
      },
    ],
    carousalImages: thailandBackground,
    imageUrl: [thailand1, thailand2, thailand, thailand3], // Replace with actual image variables
  },

  {
    title: "Japan Tour Package",
    pricing: 149800,
    originalPrice: 199999,
    duration: "7 Days / 6 Nights",
    features: [
      "Tokyo Skytree Entry",
      "Mt. Fuji Day Trip",
      "4-Star Accommodation",
      "Traditional Tea Ceremony",
      "Bullet Train Ride Experience",
      "VISA Assistance and Travel Insurance",
    ],
    itinerary: [
      {
        day: "Day 1: Arrival in Tokyo",
        detail: `Arrival in Tokyo and transfer to hotel.
                  Hotel Options:
                  3-star: Shinjuku Washington Hotel (Affordable and well-located in Shinjuku)
                  4-star: Park Hotel Tokyo (Stylish, with views of Tokyo Tower)
                  5-star: The Peninsula Tokyo (Luxurious, top-rated, in Marunouchi)`,
      },
      {
        day: "Day 2: Tokyo Sightseeing",
        detail: `Visit Senso-ji Temple, Meiji Shrine, Harajuku, Shibuya Crossing.
                  Hotel Options: Same as Day 1.`,
      },
      {
        day: "Day 3: Day Trip to Mount Fuji",
        detail: `Visit Lake Kawaguchi and Fujiyoshida.
                  Return to Tokyo in the evening.
                  Hotel Options: Same as Day 1.`,
      },
      {
        day: "Day 4: Tokyo to Kyoto",
        detail: `Travel by Shinkansen (bullet train).
                  Hotel Options in Kyoto:
                  3-star: Hotel Granvia Kyoto (Located in Kyoto Station)
                  4-star: Kyoto Hotel Okura (Classic luxury hotel)
                  5-star: The Ritz-Carlton Kyoto (Top luxury with scenic views of the Kamo River)`,
      },
      {
        day: "Day 5: Kyoto and Nara Day Trip",
        detail: `Visit Fushimi Inari Shrine, Nara Deer Park.
                  Hotel Options: Same as Day 4.`,
      },
      {
        day: "Day 6: Osaka Day Trip",
        detail: `Explore Osaka Castle, Dotonbori, Shinsaibashi.
                  Hotel Options in Osaka:
                  3-star: Hotel Nikko Osaka (Modern and affordable in central Osaka)
                  4-star: Swissotel Nankai Osaka (Convenient, with great city views)
                  5-star: The St. Regis Osaka (Luxury hotel with excellent service)`,
      },
      {
        day: "Day 7: Departure",
        detail: `Last-minute shopping and transfer to the airport.
                  Hotel Options: Same as Day 6.`,
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Bullet train pass",
      "4-Star accommodation",
    ],
    exclusions: [
      "Personal expenses",
      "Special dinner requests",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Discover Japan | Temples and Modernity",
        duration: "7 days & 6 nights",
        price: "INR 1,20,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 30,000",
        rating: 4.8,
        reviews: 300,
        image: japan1, // Replace with actual image variable
      },
      {
        id: 2,
        title: "Temples and Modernity",
        duration: "5 days & 4 nights",
        price: "INR 1,30,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 30,000",
        rating: 4.8,
        reviews: 300,
        image: japan2, // Replace with actual image variable
      },
      {
        id: 3,
        title: "Temples and Modernity",
        duration: "5 days & 4 nights",
        price: "INR 1,30,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 30,000",
        rating: 4.8,
        reviews: 300,
        image: japan2, // Replace with actual image variable
      },
      {
        id: 4,
        title: "Temples and Modernity",
        duration: "5 days & 4 nights",
        price: "INR 1,30,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 30,000",
        rating: 4.8,
        reviews: 300,
        image: japan2, // Replace with actual image variable
      },
    ],
    carousalImages: japanBackground,
    imageUrl: [japan1, japan2, japan3], // Replace with actual image variables
  },

  {
    title: "Malaysia Tour Package",
    pricing: 24990,
    originalPrice: 53000,
    duration: "5 Days / 4 Nights",
    features: [
      "Petronas Twin Towers Visit",
      "Langkawi Island Tour",
      "4-Star Hotel Accommodation",
      "Cultural Night Tour",
      "VISA Assistance and Travel Insurance",
    ],
    itinerary: [
      {
        day: "Day 1: Malaysia : Welcome to Malaysia",
        detail: `Upon arrival, get transferred to the hotel in Kuala Lumpur.
                 Rest of the day free at leisure. Overnight at Kuala Lumpur.
                 Or you can explore the nearby places.`,
      },
      {
        day: "Day 2: Malaysia : Kuala Lumpur City Sightseeing",
        detail: `Pick up for city tour of KUL. Highlights of tour: PETRONAS Twin Towers (Photo Stop), National Monument, National Mosque, Independence Square / Sultan Abdul Samad Building, King’s Palace (Photo Stop), KL Tower (Photo Stop), China Town, Central Market.
                 Back to the hotel. Evening free at leisure. Overnight at Kuala Lumpur.`,
      },
      {
        day: "Day 3: Malaysia : Batu Cave & Genting Highlands Tour",
        detail: `Get transferred from your hotel to the Genting Highlands. Enjoy a cable car ride to the top of the Genting Highlands.
                 Visit Batu Cave – one of the most prominent heritage sites of Malaysia is a series of limestone caves that date back to about 400 million years ago.
                 Back to the hotel. Evening free at leisure. Overnight at Kuala Lumpur.`,
      },
      {
        day: "Day 4: Malaysia : Day Trip to Sunway Lagoon",
        detail: `Get transferred from your hotel to Sunway Lagoon Themepark.
                 Visit the 6 zones in the theme park - Water Park, Amusement Park, Wildlife Park, Extreme Park, Scream Park, and Sunway Lost Lagoon.
                 Return to your hotel for an overnight stay in Kuala Lumpur.`,
      },
      {
        day: "Day 5: Malaysia : Departure Day",
        detail: `After checking out from the hotel, get transferred to the Kuala Lumpur International Airport to catch your flight back home.`,
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Langkawi Island tour",
      "4-Star accommodation",
    ],
    exclusions: [
      "Personal expenses",
      "Special dinner requests",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Malaysia Explorer | City and Islands",
        duration: "5 days & 4 nights",
        price: "INR 32,990",
        originalPrice: "INR 70,000",
        discount: "Save INR 37,010",
        rating: 4.4,
        reviews: 150,
        image: malaysia4, // Replace with actual image variable
      },
      {
        id: 2,
        title: "Malaysia Explorer (With flight)",
        duration: "6 days & 5 nights",
        price: "INR 52,000",
        originalPrice: "INR 60,000",
        discount: "Save INR 8,000",
        rating: 4.8,
        reviews: 150,
        image: malaysia5, // Replace with actual image variable
      },
      {
        id: 3,
        title: "Malaysia Explorer | City and Islands",
        duration: "6 days & 5 nights",
        price: "INR 24,990",
        originalPrice: "INR 54,990",
        discount: "Save INR 30,000",
        rating: 4.7,
        reviews: 150,
        image: malaysia6, // Replace with actual image variable
      },
    ],
    carousalImages: malaysiaBackground,
    imageUrl: [malaysia1, malaysia2, malaysia3], // Replace with actual image variables
  },

  {
    title: "Paris Tour Package",
    pricing: 115000,
    originalPrice: 189999,
    duration: "6 Days / 5 Nights",
    features: [
      "Eiffel Tower Entry",
      "Seine River Cruise",
      "4-Star Accommodation",
      "Versailles Palace Guided Tour",
      "Louvre Museum Entry",
      "VISA Assistance and Travel Insurance",
    ],
    itinerary: [
      {
        day: "Day 1",
        detail:
          "Arrival in Paris: Check into your hotel and take some time to rest after your flight. Evening Seine River Cruise to see Paris from the water, passing landmarks like the Eiffel Tower, Notre-Dame, the Louvre, and Musée d'Orsay.",
      },
      {
        day: "Day 2",
        detail:
          "Visit the Eiffel Tower in the morning, take an elevator ride to the top. Enjoy lunch at a nearby bistro. In the afternoon, explore Champs-Élysées, visit the Arc de Triomphe, and later visit the Louvre Museum.",
      },
      {
        day: "Day 3",
        detail:
          "Spend the entire day at Disneyland Paris, enjoying both Disneyland Park and Walt Disney Studios Park, with attractions, shows, and parades. Evening: Return to Paris for a light dinner or dessert at Angelina.",
      },
      {
        day: "Day 4",
        detail:
          "Day trip to Versailles. Explore the Palace of Versailles and its stunning gardens, including the Trianon Palaces and Marie-Antoinette's Hamlet. Return to Paris in the evening for a relaxed dinner.",
      },
      {
        day: "Day 5",
        detail:
          "Morning visit to Montmartre, including Sacré-Cœur Basilica and the artistic streets of Place du Tertre. Afterward, enjoy shopping at Galeries Lafayette or Le Bon Marché. Evening: Dinner in Le Marais or the Latin Quarter.",
      },
      {
        day: "Day 6",
        detail:
          "Morning visit to Luxembourg Gardens or Notre-Dame Cathedral. Enjoy a light lunch at a café before departure to the airport or train station.",
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Seine River Cruise",
      "4-Star accommodation",
    ],
    exclusions: [
      "Personal expenses",
      "Special dinner requests",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Romantic Paris Getaway",
        duration: "7 days & 6 nights",
        price: "INR 1,35,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 15,000",
        rating: 4.9,
        reviews: 250,
        image: paris4, // Replace with actual image variable
      },
      {
        id: 2,
        title: "Romantic Paris Getaway",
        duration: "5 days & 4 nights",
        price: "INR 1,29,000",
        originalPrice: "INR 1,40,000",
        discount: "Save INR 11,000",
        rating: 4.4,
        reviews: 250,
        image: paris5, // Replace with actual image variable
      },
      {
        id: 3,
        title: "Romantic Paris Getaway",
        duration: "5 days & 4 nights",
        price: "INR 1,10,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 40,000",
        rating: 4.8,
        reviews: 250,
        image: paris7, // Replace with actual image variable
      },
    ],
    carousalImages: parisBackground,
    imageUrl: [paris2, paris4, paris3], // Replace with actual image variables
  },

  {
    title: "Brazil Tour Package",
    pricing: 573197,
    originalPrice: 615000,
    duration: "10 Days / 9 Nights",
    features: [
      "Christ the Redeemer Visit",
      "Amazon Rainforest Tour",
      "4-Star Accommodation",
      "Rio Carnival Experience (Seasonal)",
      "Sugarloaf Mountain Cable Car",
      "VISA Assistance and Travel Insurance",
    ],
    itinerary: [
      {
        day: "Day 1: Arrival in Rio de Janeiro",
        detail: `Arrival at Rio de Janeiro Airport
                  Transfer to hotel and check-in
                  Evening at leisure, visit Copacabana Beach and enjoy the sunset
                  Hotel Options:
                  3-star: Windsor Copa Hotel (Close to Copacabana Beach, simple amenities)
                  4-star: Hotel Fasano Rio de Janeiro (Luxury beachside property with elegant design)`,
      },
      {
        day: "Day 2: Rio de Janeiro",
        detail: `Christ the Redeemer Statue (Corcovado Mountain)
                  Sugarloaf Mountain for panoramic views of the city
                  Visit Selarón Steps and Lapa Arches
                  Hotel Options: Same as Day 1`,
      },
      {
        day: "Day 3: Rio de Janeiro",
        detail: `Explore Tijuca National Park and Botanical Garden
                  Afternoon at Ipanema Beach for relaxation
                  Hotel Options: Same as Day 1`,
      },
      {
        day: "Day 4: Rio to Iguazu Falls",
        detail: `Fly to Foz do Iguaçu
                  Afternoon visit to Brazilian side of Iguazu Falls
                  Hotel Options:
                  3-star: Iguassu Holiday Hotel (Comfortable, located near the falls)
                  4-star: Belmond Hotel das Cataratas (Luxury hotel within the national park)`,
      },
      {
        day: "Day 5: Iguazu Falls (Argentina Side)",
        detail: `Full-day visit to the Argentine side of Iguazu Falls
                  Explore the trails and get up close to the falls
                  Hotel Options: Same as Day 4`,
      },
      {
        day: "Day 6: Iguazu Falls to São Paulo",
        detail: `Morning visit to the Bird Park near the falls
                  Fly to São Paulo in the afternoon
                  Hotel Options:
                  3-star: Hotel Ibis São Paulo Paulista (Budget-friendly and central location)
                  4-star: Renaissance São Paulo Hotel (Modern, with great city views)`,
      },
      {
        day: "Day 7: São Paulo",
        detail: `Visit Avenida Paulista, São Paulo Museum of Art (MASP), and Ibirapuera Park
                  Explore the city’s vibrant nightlife
                  Hotel Options: Same as Day 6`,
      },
      {
        day: "Day 8: São Paulo to Salvador",
        detail: `Fly to Salvador
                  Explore Pelourinho (UNESCO World Heritage Site), and visit Elevador Lacerda
                  Hotel Options:
                  3-star: Hotel Do Elevador (Budget option, near the historical center)
                  4-star: Fera Palace Hotel (Luxury property with beautiful views of the bay)`,
      },
      {
        day: "Day 9: Salvador",
        detail: `Visit Mercado Modelo, Igreja de Bonfim, and the Church of Nosso Senhor do Bonfim
                  Evening at Porto da Barra Beach
                  Hotel Options: Same as Day 8`,
      },
      {
        day: "Day 10: Departure from Salvador",
        detail: `Free time for shopping or exploring the local area
                  Transfer to the airport for your flight back home
                  Hotel Options: Same as Day 8`,
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Guided rainforest tour",
      "4-Star accommodation",
    ],
    exclusions: [
      "Personal expenses",
      "Special dinner requests",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Brazil Nature & Culture Tour",
        duration: "10 days & 9 nights",
        price: "INR 1,90,000",
        originalPrice: "INR 2,50,000",
        discount: "Save INR 60,000",
        rating: 4.9,
        reviews: 180,
        image: brazil1, // Replace with actual image variable
      },
      {
        id: 2,
        title: "Brazil Nature & Culture Tour",
        duration: "10 days & 9 nights",
        price: "INR 1,90,000",
        originalPrice: "INR 2,50,000",
        discount: "Save INR 60,000",
        rating: 4.9,
        reviews: 180,
        image: brazil1, // Replace with actual image variable
      },
      {
        id: 3,
        title: "Brazil Nature & Culture Tour",
        duration: "10 days & 9 nights",
        price: "INR 1,90,000",
        originalPrice: "INR 2,50,000",
        discount: "Save INR 60,000",
        rating: 4.9,
        reviews: 180,
        image: brazil1, // Replace with actual image variable
      },
    ],
    carousalImages: brazilBackground,
    imageUrl: [brazil1, brazil2, brazil3], // Replace with actual image variables
  },
  {
    title: "Paris Anniversary Package",
    pricing: 110000,
    originalPrice: 130000,
    duration: "6 Days / 5 Nights",
    features: [
      "4-Star Accommodation with Breakfast",
      "Eiffel Tower Dinner Experience",
      "Seine River Cruise",
      "Louvre Museum Entry",
      "Versailles Palace Tour",
      "Romantic Walking Tour",
    ],
    itinerary: [
      {
        day: "Day 1 - Arrival & Seine River Cruise",
        detail:
          "Arrive in Paris: Check into a luxurious hotel (e.g., Ritz Paris or Le Meurice). In the evening, start your romantic getaway with a Seine River cruise. You’ll get a beautiful view of the Eiffel Tower, Notre-Dame Cathedral, and the Louvre. Dinner at a bistro along the river or in the charming Latin Quarter.",
      },
      {
        day: "Day 2 - Eiffel Tower, Louvre & Montmartre",
        detail:
          "Eiffel Tower: Begin your day with a visit to the Eiffel Tower and consider dining at the Le 58 Tour Eiffel restaurant on the first floor. Afterward, head to the Louvre Museum to explore iconic works of art like the Mona Lisa and Venus de Milo. Skip-the-line tickets are recommended. In the evening, visit Montmartre and Sacré-Cœur Basilica for spectacular views of Paris. Enjoy dinner at a cozy Montmartre restaurant.",
      },
      {
        day: "Day 3 - Day Trip to Versailles",
        detail:
          "Take a day trip to the magnificent Palace of Versailles. Explore the opulent palace, the Hall of Mirrors, and the vast gardens. Afterward, return to Paris for dinner at a traditional French restaurant like Le Procope, one of the oldest in Paris.",
      },
      {
        day: "Day 4 - Champs-Élysées, Arc de Triomphe & Musée d'Orsay",
        detail:
          "Start your day at the famous Champs-Élysées avenue, lined with shops, cafés, and theaters. Visit the Arc de Triomphe at the end of the avenue and climb to the top for panoramic views of Paris. Spend the afternoon at the Musée d'Orsay, home to an extensive collection of Impressionist art. End your day with a gourmet dinner at a Michelin-starred restaurant like Le Meurice or L'Arpège.",
      },
      {
        day: "Day 5 - Le Marais & Shopping",
        detail:
          "Discover the trendy Le Marais neighborhood, visit the Picasso Museum, and stroll through charming streets with boutiques. Enjoy lunch in one of the chic cafés or bistros. Spend the afternoon shopping at Galeries Lafayette or high-end shops on Rue Saint-Honoré. For your last night, enjoy a memorable dinner at Le Jules Verne, a Michelin-starred restaurant located on the second floor of the Eiffel Tower with stunning views.",
      },
      {
        day: "Day 6 - Departure",
        detail:
          "On your final morning, enjoy a leisurely breakfast at a Parisian café with coffee and freshly baked croissants. Afterward, complete check-out formalities and transfer to the airport, carrying cherished memories of your romantic getaway in Paris.",
      },
    ],
    inclusions: [
      "Airport transfers",
      "Daily breakfast",
      "Sightseeing in shared vehicle",
      "Accommodation in a 4-star hotel",
    ],
    exclusions: [
      "Personal expenses",
      "Entry fees to attractions not mentioned in inclusions",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Romantic Paris Getaway",
        duration: "4 days & 3 nights",
        price: "INR 1,84,863",
        originalPrice: "INR 240,000",
        discount: "Save INR 55,137",
        rating: 4.7,
        reviews: 200,
        image: france,
      },
      {
        id: 2,
        title: "Luxury Paris Anniversary",
        duration: "5 days & 4 nights",
        price: "INR 135,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 15,000",
        rating: 4.8,
        reviews: 180,
        image: france1,
      },
      {
        id: 3,
        title: "Love in the City of Lights: Anniversary Edition",
        duration: "5 days & 4 nights",
        price: "INR 129,000",
        originalPrice: "INR 1,55,000",
        discount: "Save INR 26,000",
        rating: 4.9,
        reviews: 180,
        image: france2,
      },
    ],
    carousalImages: france5,
    imageUrl: [france3, france4, france6, france2],
  },
  {
    title: "Maldives Honeymoon Package",
    pricing: 150000,
    originalPrice: 213000,
    duration: "7 Days / 6 Nights",
    features: [
      "5-Star Overwater Villa Accommodation",
      "All-inclusive Meals and Drinks",
      "Private Candlelight Dinner on the Beach",
      "Couples Spa Treatment",
      "Snorkeling and Scuba Diving Excursions",
      "Honeymoon Decorations and Amenities",
    ],
    itinerary: [
      {
        day: "Day 1-2 - Arrival in the Maldives",
        detail:
          "Arrive at Velana International Airport and transfer to your luxury resort, either an overwater villa or a beachfront villa. Spend the day relaxing on the beach, enjoying the amenities of your villa, and soaking in the breathtaking surroundings. Overnight stay in Maldives.",
      },
      {
        day: "Day 3-4 - Leisure and Water Activities",
        detail:
          "Engage in exciting water sports such as snorkeling, kayaking, or diving to explore the vibrant marine life. Enjoy a couples spa treatment to unwind and relax. In the evening, enjoy a romantic private candlelit dinner by the beach under the stars. Overnight stay in Maldives.",
      },
      {
        day: "Day 5 - Private Excursions",
        detail:
          "Embark on a private sunset dolphin cruise to witness the playful dolphins as the sun sets over the Indian Ocean. Later, enjoy a secluded picnic on a nearby uninhabited island for a unique and private experience. Overnight stay in Maldives.",
      },
      {
        day: "Day 6 - Relaxation and Island Hopping",
        detail:
          "Spend the day relaxing at your resort or exploring the beautiful surroundings. In the afternoon, enjoy an island-hopping tour to explore nearby resorts and pristine beaches. Overnight stay in Maldives.",
      },
      {
        day: "Day 7 - Departure",
        detail:
          "Enjoy your final breakfast in the Maldives, savoring the tranquil atmosphere. Complete your check-out formalities and transfer back to Velana International Airport for your departure, carrying with you unforgettable memories of your tropical escape.",
      },
    ],
    inclusions: [
      "Airport transfers by speedboat",
      "All-inclusive meals and drinks",
      "5-Star overwater villa accommodation",
    ],
    exclusions: [
      "Personal expenses",
      "Optional excursions not mentioned in inclusions",
      "Travel during peak season",
    ],
    suggestions: [
      {
        id: 1,
        title: "Maldives Magic: Honeymoon in Paradise",
        duration: "5 days & 4 nights",
        price: "INR 1,00,000",
        originalPrice: "INR 1,25,000",
        discount: "Save INR 25,000",
        rating: 4.9,
        reviews: 300,
        image: maldives,
      },
      {
        id: 2,
        title: "Maldives Delight: Honeymoon Perfection",
        duration: "6 days & 5 nights",
        price: "INR 1,20,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 30,000",
        rating: 4.8,
        reviews: 250,
        image: maldives1,
      },
      {
        id: 3,
        title: "Maldivian Bliss: A Honeymoon Retreat",
        duration: "6 days & 5 nights",
        price: "INR 1,20,000",
        originalPrice: "INR 1,50,000",
        discount: "Save INR 30,000",
        rating: 4.8,
        reviews: 250,
        image: maldives2,
      },
    ],
    carousalImages: dubai,
    imageUrl: [maldives3, maldives4, maldives5],
  },
];
const TravelDeals = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration (in ms)
      once: false, // Whether animation should happen only once
      easing: "ease-in-out", // Animation easing
    });
  }, []);

  return (
    <div
      style={{
        backgroundImage: `url(${dubai9})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        objectFit: "cover",
      }}
      className="bg-transparent py-12"
    >
      <div className="text-center mb-12" data-aos="fade-up">
        <h2 className="text-4xl text-white font-bold">Winter Deals Promo</h2>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row justify-center items-stretch">
        {packages.slice(0, 3).map((pkg, index) => (
          <div
            key={index}
            className=" grid grid-cols-1 md:max-w-sm"
            data-aos="fade-up"
            data-aos-delay={index * 200} // Delay each card by 200ms
          >
            <TourPackageCard
              title={pkg.title}
              duration={pkg.duration}
              pricing={pkg.pricing}
              originalPrice={pkg.originalPrice}
              features={pkg.features}
              imageUrl={pkg.imageUrl}
              inclusions={pkg.inclusions}
              exclusions={pkg.exclusions}
              itinerary={pkg.itinerary}
              carousalImages={pkg.carousalImages}
              suggestions={pkg.suggestions}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TravelDeals;
